import { createLogger } from 'helpers/logger';
import { getOffersRequestParameters } from 'helpers/offer.helpers';
import { getContainerData } from 'actions/offers.actions';
import {
  FACTOR_ENUMS,
  BUREAU_ENUMS,
  BUREAU_ATTRIBUTE_NAME_MAP,
  FACTOR_ATTRIBUTE_NAME_MAP,
} from 'pages/RedesignDashboard/constants';
import { RESET_PAYMENT_HISTORY_CONTAINER_DATA } from 'types/paymentHistoryContainer.constants';
import { RESET_CREDIT_USAGE_CONTAINER_DATA } from 'types/creditUsageContainer.constants';
import { RESET_ACCOUNT_MIX_CONTAINER_DATA } from 'types/accountMixContainer.constants';
import { RESET_CREDIT_AGE_CONTAINER_DATA } from 'types/creditAgeContainer.constants';
import { RESET_CREDIT_INQUIRIES_CONTAINER_DATA } from 'types/creditInquiriesContainer.constants';
import { RESET_PROFILE_CONTAINER_DATA } from 'types/profileContainer.constants';
import { RESET_TODAY_CONTAINER_DATA } from 'types/todayContainer.constants';
import {
  SELECT_1B_3B_FACTOR,
  SELECT_1B_3B_BUREAU,
  RESET_1B_3B_FACTOR_BUREAU,
} from 'types/score1b3bFactorDial.constants';
import { getCardModule } from 'helpers/offer.helpers';
import { getUserInfo } from './userInfo.actions';
import { RESET_POTENTIAL_CREDIT_PROFILE_CONTAINER_DATA } from 'types/potentialContainer.constans';

const logger = createLogger({
  name: 'dashboard.actions',
});

const {
  PAYMENT_HISTORY,
  ACCOUNT_MIX,
  CREDIT_AGE,
  CREDIT_INQUIRIES,
  CREDIT_USAGE,
  POTENTIAL_CREDIT_PROFILE,
  DEFAULT,
} = FACTOR_ENUMS;

const { TRANS_UNION } = BUREAU_ENUMS;

export const loadDashboardDependencies = props => dispatch => {
  const {
    isPlusUser,
    plUpsellModuleTargetingQueryParams,
    plPrequalOfferQueryParams,
  } = props;
  const paramsFromFlag = getOffersRequestParameters();
  const queryParams = {
    guaranteeBadge: paramsFromFlag?.guaranteeBadge,
    cciVersion: paramsFromFlag?.cciVersion,
    rankingType: paramsFromFlag?.rankingType,
    approvalOddsBadgeOverride: paramsFromFlag?.approvalOddsBadgeOverride,
    includeSuggestedCardForPlusUser: isPlusUser,
    ...plUpsellModuleTargetingQueryParams,
    ...plPrequalOfferQueryParams,
  };
  return new Promise((resolve, reject) => {
    Promise.all([
      dispatch(getContainerData('CREDIT_PROFILE', queryParams)),
      dispatch(getContainerData('TODAY', queryParams)),
    ])
      .then(response => {
        const isDownloaded = response[0]?.is3bReportDownloaded;
        if (isDownloaded) {
          dispatch(getUserInfo());
        }
        resolve(response);
      })
      .catch(err => {
        logger.reportAPIError(err);
        reject(err);
      });
  });
};

export const loadPotentialCreditProfileContainer =
  (selectedBureau, showPotentialFactor = true) =>
  (dispatch, getState) => {
    const { potentialCreditProfileContainer } = getState();

    const {
      potentialCreditProfileContainerLoading,
      potentialCreditProfileContainerError,
    } = potentialCreditProfileContainer;

    return new Promise((resolve, reject) => {
      if (
        (!potentialCreditProfileContainer?.potentialCreditProfileContainer &&
          !potentialCreditProfileContainerLoading) ||
        potentialCreditProfileContainerError
      ) {
        const { cciVersion, rankingType } = getOffersRequestParameters();
        dispatch(
          getContainerData(POTENTIAL_CREDIT_PROFILE, {
            cciVersion,
            rankingType,
          }),
        )
          .then(response => {
            resolve(response);
          })
          .catch(err => {
            logger.reportAPIError(err);
            reject(err);
          });
      }

      if (showPotentialFactor) {
        dispatch(
          load1b3bFactorDetails({
            selectedFactor: POTENTIAL_CREDIT_PROFILE,
            selectedBureau: selectedBureau,
          }),
        );
      }
    });
  };

export const getPaymentHistoryContainer =
  ({ bureau = TRANS_UNION }) =>
  dispatch => {
    const paramsFromFlag = getOffersRequestParameters();
    let queryParams = {
      bureau: bureau,
      guaranteeBadge: paramsFromFlag?.guaranteeBadge,
      cciVersion: paramsFromFlag?.cciVersion,
      rankingType: paramsFromFlag?.rankingType,
      approvalOddsBadgeOverride: paramsFromFlag?.approvalOddsBadgeOverride,
    };
    return new Promise((resolve, reject) => {
      dispatch(getContainerData(PAYMENT_HISTORY, queryParams))
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          logger.reportAPIError(err);
          reject(err);
        });
    });
  };

export const getCreditUsageContainer =
  ({ bureau = TRANS_UNION }) =>
  dispatch => {
    const paramsFromFlag = getOffersRequestParameters();
    let queryParams = {
      bureau: bureau,
      guaranteeBadge: paramsFromFlag?.guaranteeBadge,
      cciVersion: paramsFromFlag?.cciVersion,
      rankingType: paramsFromFlag?.rankingType,
      approvalOddsBadgeOverride: paramsFromFlag?.approvalOddsBadgeOverride,
    };

    return new Promise((resolve, reject) => {
      dispatch(getContainerData(CREDIT_USAGE, queryParams))
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          logger.reportAPIError(err);
          reject(err);
        });
    });
  };

export const getAccountMixContainer =
  ({ bureau = TRANS_UNION }) =>
  dispatch => {
    const paramsFromFlag = getOffersRequestParameters();
    let queryParams = {
      bureau: bureau,
      guaranteeBadge: paramsFromFlag?.guaranteeBadge,
      cciVersion: paramsFromFlag?.cciVersion,
      rankingType: paramsFromFlag?.rankingType,
      approvalOddsBadgeOverride: paramsFromFlag?.approvalOddsBadgeOverride,
    };
    return new Promise((resolve, reject) => {
      dispatch(getContainerData(ACCOUNT_MIX, queryParams))
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          logger.reportAPIError(err);
          reject(err);
        });
    });
  };

export const getCreditAgeContainer =
  ({ bureau = TRANS_UNION }) =>
  dispatch => {
    const paramsFromFlag = getOffersRequestParameters();
    let queryParams = {
      bureau: bureau,
      guaranteeBadge: paramsFromFlag?.guaranteeBadge,
      cciVersion: paramsFromFlag?.cciVersion,
      rankingType: paramsFromFlag?.rankingType,
      approvalOddsBadgeOverride: paramsFromFlag?.approvalOddsBadgeOverride,
    };
    return new Promise((resolve, reject) => {
      dispatch(getContainerData(CREDIT_AGE, queryParams))
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          logger.reportAPIError(err);
          reject(err);
        });
    });
  };

export const getCreditInquiriesContainer =
  ({ bureau = TRANS_UNION }) =>
  dispatch => {
    const paramsFromFlag = getOffersRequestParameters();
    let queryParams = {
      bureau: bureau,
      guaranteeBadge: paramsFromFlag?.guaranteeBadge,
      cciVersion: paramsFromFlag?.cciVersion,
      rankingType: paramsFromFlag?.rankingType,
      approvalOddsBadgeOverride: paramsFromFlag?.approvalOddsBadgeOverride,
    };
    return new Promise((resolve, reject) => {
      dispatch(getContainerData(CREDIT_INQUIRIES, queryParams))
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          logger.reportAPIError(err);
          reject(err);
        });
    });
  };

export const resetPaymentHistoryContainerData = () => ({
  type: RESET_PAYMENT_HISTORY_CONTAINER_DATA,
});

export const resetCreditUsageContainerData = () => ({
  type: RESET_CREDIT_USAGE_CONTAINER_DATA,
});

export const resetAccountMixContainerData = () => ({
  type: RESET_ACCOUNT_MIX_CONTAINER_DATA,
});

export const resetCreditAgeContainerData = () => ({
  type: RESET_CREDIT_AGE_CONTAINER_DATA,
});

export const resetCreditInquiriesContainerData = () => ({
  type: RESET_CREDIT_INQUIRIES_CONTAINER_DATA,
});

export const resetTodayContainerData = () => ({
  type: RESET_TODAY_CONTAINER_DATA,
});

export const resetPotentialCreditProfileContainerData = () => ({
  type: RESET_POTENTIAL_CREDIT_PROFILE_CONTAINER_DATA,
});

export const resetProfileContainerData = () => ({
  type: RESET_PROFILE_CONTAINER_DATA,
});

export const reset1b3bFactorBureau = () => ({
  type: RESET_1B_3B_FACTOR_BUREAU,
});

export const select1b3bFactor = ({
  selectedFactor,
  selectedFactorGrade = null,
}) => ({
  type: SELECT_1B_3B_FACTOR,
  selectedFactor,
  selectedFactorGrade,
});

export const load1b3bFactorDetails =
  ({ selectedFactor, selectedBureau }) =>
  (dispatch, getState) => {
    const { profileContainer } = getState();
    const bureauFactorDetails = getCardModule(
      profileContainer?.profileContainer,
      'ALL_BUREAU_CREDIT_FACTORS',
    )?.additionalData?.bureauFactorDetails;

    const bureauDetail =
      bureauFactorDetails?.[BUREAU_ATTRIBUTE_NAME_MAP.get(selectedBureau)];
    const factorDetail =
      bureauDetail?.[FACTOR_ATTRIBUTE_NAME_MAP.get(selectedFactor)];

    dispatch(
      select1b3bFactor({
        selectedFactor: selectedFactor,
        selectedFactorGrade: factorDetail?.grade,
      }),
    );
  };

export const select1b3bBureau = ({ selectedBureau }) => ({
  type: SELECT_1B_3B_BUREAU,
  selectedBureau,
});

export const resetAllFactorsStates = () => dispatch => {
  dispatch(resetPaymentHistoryContainerData());
  dispatch(resetCreditUsageContainerData());
  dispatch(resetAccountMixContainerData());
  dispatch(resetCreditAgeContainerData());
  dispatch(resetCreditInquiriesContainerData());
  dispatch(resetProfileContainerData());
  dispatch(resetTodayContainerData());
  dispatch(reset1b3bFactorBureau());
  dispatch(resetPotentialCreditProfileContainerData());
};

export const loadContainerDashboard = props => dispatch => {
  return new Promise((resolve, reject) => {
    const { bureau, getContainer, factor } = props || {
      bureau: TRANS_UNION,
      getContainer: getPaymentHistoryContainer,
      factor: PAYMENT_HISTORY,
    };
    if (!bureau || !getContainer || !factor) reject();
    Promise.all([
      dispatch(getContainer({ bureau })),
      dispatch(
        load1b3bFactorDetails({
          selectedFactor: factor,
          selectedBureau: bureau,
        }),
      ),
    ])
      .then(resolve)
      .catch(reject);
  });
};

const FACTOR_TYPES = {
  PAYMENT_HISTORY: {
    container: 'paymentHistoryContainer',
    get: getPaymentHistoryContainer,
  },
  CREDIT_USAGE: {
    container: 'creditUsageContainer',
    get: getCreditUsageContainer,
  },
  CREDIT_AGE: {
    container: 'creditAgeContainer',
    get: getCreditAgeContainer,
  },
  ACCOUNT_MIX: {
    container: 'accountMixContainer',
    get: getAccountMixContainer,
  },
  CREDIT_INQUIRIES: {
    container: 'creditInquiriesContainer',
    get: getCreditInquiriesContainer,
  },
};

export const loadFactorContainer =
  (factor, selectedBureau) => (dispatch, getState) => {
    const factorContainer = getState()[FACTOR_TYPES[factor]?.container];
    const container = factorContainer[FACTOR_TYPES[factor]?.container];
    const { containerLoading, containerError } = factorContainer;

    if (!container && !containerLoading && !containerError) {
      dispatch(
        loadContainerDashboard({
          bureau: selectedBureau,
          getContainer: FACTOR_TYPES[factor]?.get,
          factor,
        }),
      );
    }
    dispatch(
      load1b3bFactorDetails({
        selectedFactor: factor,
        selectedBureau: selectedBureau,
      }),
    );
  };

export const setSelectedFactorToToday = () => dispatch => {
  dispatch(select1b3bFactor({ selectedFactor: DEFAULT }));
};
